"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryBox = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _LazyImage = require("../LazyImage");
var _constants = require("./constants");
var _styles = require("./styles");
var _types = require("./types");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns link to a category. Contains image and name of the category. Displays button on hover.
 * Renders if `imageUrl`, `relativeUrl` and `title` have thruthy values.
 */
const CategoryBox = ({
  buttonText,
  className,
  description,
  imageUrl,
  relativeUrl,
  size = _types.CategoryBoxSize.SMALL,
  title
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const width = (0, _utils.getCategoryBoxWidth)({
    size
  });
  const height = (0, _utils.getCategoryBoxImageHeight)({
    size
  });
  const imagesVariants = (0, _react.useMemo)(() => imageUrl ? (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)({
    url: imageUrl,
    backgroundColor: theme.palette.grey[100],
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      width: width.mobile,
      quality: 90
    }, {
      width: width.desktop,
      quality: 90
    }]
  })) : undefined, [imageUrl, theme.palette.grey, width.desktop, width.mobile]);
  if (!relativeUrl || !title) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.CATEGORY_BOX),
    href: relativeUrl,
    widthValues: width,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ImageWrapper, {
      heightValues: height,
      widthValues: width,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyImage.LazyImage, {
        role: "presentation",
        sizes: `(max-width: ${theme.breakpoints.values.sm - 1}px) ${width.mobile}px, ${width.desktop}px`,
        srcSet: imagesVariants
      }), buttonText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ViewButtonWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          "data-testid": getTestId(_constants.CATEGORY_BOX_BUTTON),
          variant: "contained",
          color: "primary",
          children: buttonText
        })
      }) : null]
    }), description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      color: "textSecondary",
      children: description
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
      variant: "subtitle1",
      component: "p",
      textAlign: "center",
      color: "textPrimary",
      fontWeight: "bold",
      textTransform: "uppercase",
      children: title
    })]
  });
};
exports.CategoryBox = CategoryBox;
